<template>
  <section class="container">
    <b-tabs type="is-rounded">
      <b-tab-item label="View All">
        <template slot="header">
          <span> View All </span>
        </template>
        <div class="" style="margin:2% auto">
          <div class="columns">
            <div class="column is-full">

              <b-table :paginated="isPaginated" :per-page="perPage" :current-page.sync="currentPage"
                :pagination-simple="isPaginationSimple" :pagination-position="paginationPosition"
                v-if="equipmentTypes" :data="isEmpty ? [] : equipmentTypes" :bordered="true" :striped="true"
                :narrowed="true" :hoverable="true" :loading="isLoading" :focusable="true" :selected-sync="selected"
                :mobile-cards="true">

                <template slot-scope="props">
                  <b-table-column field="name" label="Name">
                    {{ props.row.name }} {{props.row.extra ? `(${props.row.extra})` : ''}}
                  </b-table-column>

                  <b-table-column field="fare" label="Fare">
                    {{props.row.fare}}
                  </b-table-column>

                  <b-table-column field="description" label="Description">
                      {{ props.row.description }}
                  </b-table-column>

                  <b-table-column field="action" label="Action">
                    <!-- <b-switch v-model="props.row.available" @input="setProductAvailability(props.row)" :true-value="'true'" :false-value="'false'">
                    </b-switch> -->
                    <b-tooltip label="Edit">
                      <button class="button is-primary " @click="openEditEquipmentTypeModal(props.row)">
                        <b-icon icon="pencil" size="is-small">
                        </b-icon>
                      </button>
                    </b-tooltip>
                    <b-tooltip class=" is-danger " label="Delete">
                      <button class="button is-danger " @click="openDeleteEquipmentTypeModal(props.row)">
                        <b-icon icon="delete" size="is-small">
                        </b-icon>
                      </button>
                    </b-tooltip>
                  </b-table-column>
                  <!-- <b-table-column field="id" label="Product ID">
                    {{ props.row.id }}
                  </b-table-column> -->
                </template>

                <template slot="empty" v-if="!isLoading && equipmentTypes.length == 0">
                  <section class="section">
                    <div class="content has-text-grey has-text-centered">
                      <p>
                        <b-icon icon="emoticon-sad" size="is-large">
                        </b-icon>
                      </p>
                      <p>Nothing here.</p>
                    </div>
                  </section>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </b-tab-item>

      <b-tab-item label="Add Equipment Type">
        <template slot="header">
          <span> Add Equipment Type </span>
        </template>
        <div class="" style="margin:2% auto">
          <div class="columns">
            <div class="column is-full">
              <form v-on:submit.prevent="createEquipmentType" class="column is-half">

                  <b-field label="Name">
                    <b-input v-model="newEquipmentType.name" placeholder required></b-input>
                  </b-field>
                  <b-field label="Fare">
                    <b-input v-model="newEquipmentType.fare" placeholder required></b-input>
                  </b-field>
                  <b-field label="Description">
                    <b-input type="textarea" v-model="newEquipmentType.description"></b-input>
                  </b-field>
                  <div>
                      <button class="button is-primary" type="submit">Create</button>
                  </div>
              </form>
            </div>
          </div>
        </div>
      </b-tab-item>
    </b-tabs>
  </section>
</template>

<script>
  const EditEquipmentTypeModal = () => import('@/components/EquipmentTypes/EditEquipmentTypeModal');
  const DeleteEquipmentTypeModal = () => import('@/components/EquipmentTypes/DeleteEquipmentTypeModal');
  import {
    ucFirst
  } from '@/helpers';
  import {
    mapActions
  } from 'vuex';

  const defaultEquipmentType = () => {
    return {
      name: '',
      description: '',
      fare: 0
    }
  }
  export default {
    name: "EquipmentTypes",
    data() {
      return {
        equipmentTypesLoading: false,
        isPaginated: true,
        isPaginationSimple: false,
        paginationPosition: 'bottom',
        defaultSortDirection: 'asc',
        sortIcon: 'arrow-up',
        sortIconSize: 'is-small',
        currentPage: 1,
        perPage: 50,
        isLoading: false,
        selected: [],
        equipmentTypes: [],
        currentEquipmentType: "",
        newEquipmentType: defaultEquipmentType(),

      }
    },
    computed: {
      isEmpty() {
        return this.isLoading == true && this.equipmentTypes.filter(pT => pT.id == this.currentEquipmentType)[0].products
          .length == 0;
      }
    },
    created() {
      this.getEquipmentTypes()
    },
    methods: {
      ...mapActions([
        'editProduct'
      ]),
      getEquipmentTypes() {
        const loading = this.$loading.open();
        this.$store.dispatch('getEquipmentTypes').then(({meta, equipmentTypes}) => {
          loading.close()
          if (equipmentTypes && equipmentTypes.length > 0) {
            this.equipmentTypes = equipmentTypes;
          } else {
            this.$toasted.global.error('Product types not found.');
          }
        }).catch(e => {
          loading.close()
          console.log('Exception when getting product types for Products tabs', e);
          this.$toasted.global.error('Failed to get product types.');
        })
      },
      openEditEquipmentTypeModal(equipmentType) {
        this.$modal.open({
          component: EditEquipmentTypeModal,
          parent: this,
          props: {
            equipmentType
          },
          events: {
            closeModal: () => {
              this.getEquipmentTypes();
            }
          }
        })
      },
      openDeleteEquipmentTypeModal(equipmentType) {
        this.$modal.open({
          component: DeleteEquipmentTypeModal,
          parent: this,
          props: {
            equipmentType
          },
          events: {
            reload: () => {
              this.getEquipmentTypes();
            }
          }
        })
      },
      createEquipmentType() {
        const loading = this.$loading.open();

        this.$store.dispatch('createEquipmentType', this.newEquipmentType).then(newEquipment=> {
          loading.close();
          this.$toasted.global.success(`Equipment Type ${this.newEquipmentType.name} Created!`)
          this.newEquipmentType = defaultEquipmentType();
          this.getEquipmentTypes()
        }).catch(e=> {
          console.log('Exception when creating product', e);
          loading.close();
          this.$toasted.global.error('Failed to create equipment type');
        })

      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Equipment/EquipmentTypes.vue